module.exports = __webpack_public_path__ + "img/world_on.144d9525.png";